var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carriers-selector"},[_c('el-transfer',{attrs:{"titles":['Transporteurs disponibles', 'Transporteurs exclues'],"value":_vm.value,"data":_vm.list},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }